<template lang="pug">
div
  el-row
    div.margin-top-title
      b Camadas de Bloqueio
      div.margin-top-subtitle(v-if="intersecaoComCamadaDeBloqueio")
        span Este processo contém interseção com áreas fora de jurisdição do {{orgao}} para regularização fundiária.
        el-table(
          :data="arquivos"
          stripe
          style="width: 100%"
          :show-header="false"
        )
          el-table-column(prop="nome")
          el-table-column(align="right")
            template(slot-scope="scope")
              el-button(size="mini" @click="visualizar(numeroProcesso, scope.row.tipo)")
                font-awesome-icon(icon="eye", size="lg")
      div.margin-top-subtitle(v-else)
        span Este processo não contém interseção com áreas fora de jurisdição do {{orgao}} para regularização fundiária.
    div.margin-top-title(v-if="possuiAlerta && !isPara")
      b Camadas de Alerta
      div.margin-top-subtitle
        span Este processo contém interseção com camadas de alerta.
        el-table(
          :data="arquivosAlerta"
          stripe
          style="width: 100%"
          :show-header="false"
        )
          el-table-column(prop="nome")
          el-table-column(align="right")
            template(slot-scope="scope")
              el-button(size="mini" @click="visualizar(numeroProcesso, scope.row.tipo)")
                font-awesome-icon(icon="eye", size="lg")
    div.margin-top-title(v-if="isPara")
      b Monitoramento ambiental
      div.margin-top-subtitle(v-if="intersecaoComMonitoramentoAmbiental")
        i.fal(class="fa fa-exclamation-triangle cor-warning", v-if="!statusIconeAlerta.includes(monitoramento.cruzamentoAmbiental.dados.statusAmbiental)")
        el-row(v-if="monitoramento.cruzamentoAmbiental.dados.camadas.length")
          el-col(:span="10")
            div.margin-top-title
              div
                  span Uso e cobertura do solo
              el-select(v-model="anoSelecionado" placeholder="Selecione o ano")
                el-option(
                  v-for="camada in monitoramento.cruzamentoAmbiental.dados.camadas[0].urls"
                  :key="camada.ano"
                  :label="camada.ano"
                  :value="camada.ano"
                )
            img.img-mapa(v-for="camada in monitoramento.cruzamentoAmbiental.dados.camadas[0].urls", v-show="camada.ano === anoSelecionado" , :src="camada.url" , width="400px")
          el-col(:span="10")
            div.margin-top-title
              div
                span Desmatamento
              el-select(v-model="anoSelecionadoMonitoramento" placeholder="Selecione o ano")
                el-option(
                  v-for="camada in monitoramento.cruzamentoAmbiental.dados.camadas[1].urls"
                  :key="camada.ano"
                  :label="camada.ano"
                  :value="camada.ano"
                )
            img.img-mapa(v-for="camada in monitoramento.cruzamentoAmbiental.dados.camadas[1].urls", v-show="camada.ano === anoSelecionadoMonitoramento" , :src="camada.url" , width="400px")
          el-col(:span="4")
            img.img-legenda(:src="monitoramento.urlLegenda", width="150px")
      div
        span(v-if="!isLaudoMonitoramento") Mapa e Laudo ainda não processados
        el-table(
          v-if="isLaudoMonitoramento"
          :data="arquivosLaudo"
          stripe
          style="width: 100%"
          :show-header="false"
        )
          el-table-column(prop="nome")
          el-table-column(align="right")
            template(slot-scope="scope")
              el-button(size="mini" @click="visualizar(numeroProcesso, scope.row.tipo)")
                font-awesome-icon(icon="eye", size="lg")
    div.margin-top-title(v-if="isPara")
      el-row
        el-col(:span="24")
          b Uso e cobertura do solo
        el-col(:span="24")
          div(v-if="isMapaUsoECobertura")
            el-table(
              :data="arquivoCobertura"
              stripe
              style="width: 100%"
              :show-header="false"
            )
              el-table-column(prop="nome")
              el-table-column(align="right")
                template(slot-scope="scope")
                  el-button(size="mini" @click="visualizar(numeroProcesso, scope.row.tipo)")
                    font-awesome-icon(icon="eye", size="lg")
          div(v-else)
            span Mapa de uso e cobertura do solo ainda em processamento.
</template>

<script>
import { mapActions } from 'vuex'
import AppPar from '@/components/AppPar'
const dadosEstado = require('@/constants/' + process.env.ESTADO + '/dadosEstado')

export default {

  components: {
    AppPar
  },

  props: ['idProcesso', 'numeroProcesso'],

  data () {
    return {
      orgao: dadosEstado.default.ORGAO,
      intersecaoComCamadaDeBloqueio: false,
      intersecaoComMonitoramentoAmbiental: false,
      isPara: process.env.ESTADO === 'pa',
      isMapaUsoECobertura: false,
      possuiAlerta: false,
      isLaudoMonitoramento: false,
      statusIconeAlerta: ['STATUS1', 'STATUS2'],
      arquivos: [
        {
          nome: 'Mapa das interseções com as camadas de bloqueio',
          tipo: 'MAPA'
        },
        {
          nome: 'Laudo',
          tipo: 'LAUDO'
        }
      ],
      arquivosLaudo: [
        {
          nome: 'Mapa de monitoramento ambiental',
          tipo: 'MAPA_MONITORAMENTO'
        },
        {
          nome: 'Laudo de monitoramento ambiental',
          tipo: 'LAUDO_MONITORAMENTO'
        }
      ],
      arquivoCobertura: [
        {
          nome: 'Mapa de uso e cobertura do solo',
          tipo: 'MAPA_USO_COBERTURA'
        }
      ],
      arquivosAlerta: [
        {
          nome: 'Mapa das interseções com as camadas de alerta',
          tipo: 'MAPA'
        },
        {
          nome: 'Laudo',
          tipo: 'LAUDO'
        }
      ],
      anoSelecionado: null,
      anoSelecionadoMonitoramento: null,
      monitoramento: {
        cruzamentoAmbiental: {
          dados: {
            camadas: []
          }
        }
      }
    }
  },

  async created () {
    this.monitoramento = await this.getCruzamentoMonitoramento(this.numeroProcesso)
    this.intersecaoComCamadaDeBloqueio = this.monitoramento.statusBloqueio === 'BLOQUEADO'
    /*
      // parte e codico comentada devido a erro na visualização das imagens de monitoramento de processo no geoserver
      // passamos a visualizar pelo pdf de laudo de monitorsamento gerado pelo arcgis
    */
    // this.intersecaoComMonitoramentoAmbiental = !!this.monitoramento.cruzamentoAmbiental
    this.isMapaUsoECobertura = !!this.monitoramento.usoCobertura
    this.isLaudoMonitoramento = !!this.monitoramento.possuiLaudoMonitoramento
    this.possuiAlerta = !!this.monitoramento.possuiAlerta
    if (this.intersecaoComMonitoramentoAmbiental) {
      const camadaMonitoramento = this.monitoramento.cruzamentoAmbiental.dados.camadas.find(c => c.tipo === 'MAPBIOMAS')
      const camadaProces = this.monitoramento.cruzamentoAmbiental.dados.camadas.find(c => c.tipo === 'PRODES')
      if (camadaMonitoramento) {
        this.anoSelecionado = camadaMonitoramento.urls[0].ano
      }
      if (camadaProces) {
        this.anoSelecionadoMonitoramento = camadaProces.urls[0].ano
      }
    }
  },

  methods: {
    ...mapActions({
      getCruzamentoMonitoramento: 'monitoramentoAmbiental/getCruzamentoMonitoramento'
    }),

    visualizar (numero, tipo) {
      window.open(`${process.env.ROOT_URL}publico/bloqueioDinamico/view/a4972611-7a5b-43fc-a5b4-9e5c2adcf73b?numero=${numero}&tipo=${tipo}`, `Visualizar processo ${numero}`, 'height=500,width=800,top=250px,left=250px,right=150px')
    }

  }

}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.emptyHistorico {
  display: flex;
  justify-content: center;
}

.descricao {
  font-size: 13px;
}

.cor-warning {
  color: hsl(32, 100%, 50%);
}

.ml-10 {
  margin-left: 10px;
}

.align-center {
  display: flex;
  justify-content: center;
  width: '100%';
}

.margin-top-title {
  margin-top: 10px;
}

.margin-top-subtitle {
  margin-top: 10px;
}

/deep/ .el-step__icon.is-text {
  border: none;
  width: 100%;
}

/deep/ .el-step__title.is-process {
  color: $color-primary;
}

/deep/ .el-step__title.is-wait,
/deep/ .el-step__head.is-wait,
/deep/ .el-step__title.is-finish,
/deep/ .el-step__head.is-finish {
  color: black;
  border-color: black;
  opacity: 0.7;
}

/deep/ .el-step__head.is-wait,
/deep/ .el-step__head.is-finish {
  color: black;
  .el-step__line {
    background-color: black;
  }
}

/deep/ .el-step__head.is-process {
  color: $color-primary;
  font-weight: bold;
  .circle {
    background: $color-primary;
  }
  .el-step__line {
    background-color: $color-primary;
  }
  .el-step__icon.is-text {
    border-color: $color-primary;
  }
  .date-pad {
    color: $color-primary;
  }
}

/deep/ .el-step.is-vertical .el-step__line {
  left: 145px;
  margin-top: 5px;
}

/deep/ .el-step__description {
  margin-top: 10px !important;
  padding-left: 30px;
}

.inactive-step {
  flex-basis: 7% !important;
}

.active-step {
  flex-basis: unset !important;
}

/deep/ .el-step__head {
  cursor: pointer;
  width: 20% !important;
}

/deep/ .el-step__main {
  width: 80% !important;
  padding-left: 20px !important;
  padding-bottom: 10px;
  .el-step__title {
    cursor: pointer;
  }
}

.modal {
  height: 71vh;
}

.descricao {
  font-size: 13px;
}

.steps {
  padding: 20px;
}

.painel-historico {
  max-height: 65vh;
  overflow-y: auto;
}

.btn-baixar-pdf {
  float: right;
  padding: 13px 30px;
  font-size: 15px;
  margin-top: 15px;
  margin-right: 25px;
  margin-bottom: 15px;
}
.margin-left {
  margin-left: 5px;
}

.circle {
  border: black;
  border-radius: 50%;
  background: black;
  width: 16px;
  height: 16px;
}

.date-pad {
  padding-right: 25px;
  opacity: 0.6;
}

.img-legenda {
  margin-top: 80px;
}

.img-mapa {
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppVisualizarMonitoramentoAreaTab.vue